import React, { createContext, useContext, useState } from 'react'

interface FeedbackModalContextType {
    isOpen: boolean
    open: () => void
    close: () => void
    toggle: () => void
}

const FeedbackModalContext = createContext<FeedbackModalContextType>({
    isOpen: false,
    open: () => {},
    close: () => {},
    toggle: () => {},
})

export const FeedbackModalProvider = ({ children }: { children: React.ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false)

    const open = () => {
        setIsOpen(true)
    }

    const close = () => {
        setIsOpen(false)
    }

    const toggle = () => {
        setIsOpen((prev) => !prev)
    }

    return (
        <FeedbackModalContext.Provider value={{ isOpen, open, close, toggle }}>
            {children}
        </FeedbackModalContext.Provider>
    )
}

export const useFeedbackModal = () => {
    return useContext(FeedbackModalContext)
}
